import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "redux/store";
import { ActionPayload } from "types/Others";

type ContentTypeState = {
  selectedContentType: any | null;
  isLoading: boolean;
  isChatRunning?: boolean;
};

const initialState: ContentTypeState = {
    selectedContentType: null,
    isLoading: false,
    isChatRunning: false
};

export const contentTypeSlice = createSlice({
  name: "contentTypeState",
  initialState,
  reducers: {
    setContentTypeState: (state, action: PayloadAction<any>) => {
        const val = action.payload;
        console.log("val in slice--<",val)
        state.selectedContentType = val
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
        state.isLoading = action.payload;
    },
    setChatRunning: (state, action: PayloadAction<boolean>) => {
        state.isChatRunning = action.payload;
    }
  }
});

export const { setContentTypeState,setLoading,setChatRunning } =contentTypeSlice.actions;

export default contentTypeSlice.reducer;
export const selectContentType = (state: RootState) => state;